export default __webpack_public_path__ + "static/media/BlogPic1.38963afa.jpg";